import { __, assign, update } from 'lodash/fp';

import { keyById } from '@mews/fp';
import { createReducer } from '@mews/framework';
import { RATE_GROUPS_SET } from '../entities/rateGroups/actionTypes';
import { RATES_SET } from '../entities/rates/actionTypes';

const initialState = {};

export const hotelsReducer = createReducer(initialState, {
    [RATES_SET]: (state: $TSFixMe, { enterpriseId, rates }: $TSFixMe) =>
        update([enterpriseId, 'rates'], assign(__, keyById(rates)), state),
    [RATE_GROUPS_SET]: (state: $TSFixMe, { enterpriseId, rateGroups }: $TSFixMe) =>
        update([enterpriseId, 'rateGroups'], assign(__, keyById(rateGroups)), state),
});
